export default __webpack_public_path__ + "static/media/car-with-lady-illustration.d3979f26.svg";